// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__vFoVS","approved":"Status_approved__6nz7O","rejected":"Status_rejected__3CuRH","expired":"Status_expired__2fDzz","label":"Status_label__3izp5"};